module.exports = __webpack_public_path__ + "static/2- Rudbeckia lacinata-306260fae6d9aa283b7fa60d7eb430c5.jpg";